import type { ActivationFlowDefinition } from "../types";

export const firstExportAudioFlow: ActivationFlowDefinition = {
    id: "first_export_audio",
    title: "First Export Audio Workflow",
    steps: [
        {
            id: "intro_editor",
            title: "Welcome to the editor",
            target: "[data-tour='editor-workspace-area']",
            placement: "center",
            spotlightPadding: 14,
            content:
                "In this quick demo, we'll cleanup this clip's audio using Studio Sound.",
            advance: {
                type: "manual",
            },
        },
        {
            id: "select_timeline_clip",
            title: "Select your clip",
            target: "[data-tour='timeline-clip']",
            placement: "top",
            content: "This is your clip. Click it to select it.",
            advance: {
                type: "click",
                selector: "[data-tour='timeline-clip']",
            },
        },
        {
            id: "open_properties_sidebar",
            title: "Open Properties",
            target: "[data-tour='sidebar-properties-button']",
            placement: "left",
            content:
                "Open clip properties. This panel lets you adjust settings for your selected clip.",
            advance: {
                type: "click",
                selector: "[data-tour='sidebar-properties-button']",
            },
        },
        {
            id: "enable_studio_sound",
            title: "Enable Studio Sound",
            target: "[data-tour='studio-sound-toggle']",
            placement: "left",
            content:
                "Turn on Studio Sound to remove background noise and improve clarity. Processing audio may take a few seconds.",
            preStepAction: "open_properties_sidebar",
            advance: {
                type: "click_then_condition",
                selector: "[data-tour='studio-sound-toggle']",
                condition: "studio_sound_ready",
            },
        },
        {
            id: "hear_difference_play",
            title: "Hear the result",
            target: "[data-tour='timeline-play-toggle']",
            placement: "top",
            content: "Press Play to hear the enhanced audio. Notice the cleaner waveform and voice.",
            advance: {
                type: "click",
                selector: "[data-tour='timeline-play-toggle']",
            },
            autoAdvanceDelayMs: 1000,
        },
        {
            id: "compare_studio_sound",
            title: "Compare on and off",
            target: "[data-tour='studio-sound-toggle']",
            placement: "left",
            content:
                "Toggle Studio Sound off and on while listening to compare. Leave it on when you're ready, then continue.",
            preStepAction: "open_properties_sidebar",
            advance: {
                type: "manual",
            },
        },
        {
            id: "open_export_menu",
            title: "Export your composition",
            target: "[data-tour='editor-export-button']",
            placement: "bottom",
            content: "Click Export to open export settings.",
            advance: {
                type: "click",
                selector: "[data-tour='editor-export-button']",
            },
        },
        {
            id: "start_export",
            title: "Start export",
            target: "[data-tour='export-card-submit']",
            placement: "left",
            content: "Click Export to render your first episode.",
            advance: {
                type: "click",
                selector: "[data-tour='export-card-submit']",
            },
        },
    ],
};
